import { isNil, isNaN } from 'lodash';
import makeStyles from '@mui/styles/makeStyles';
import Paper from '@mui/material/Paper';
import usePage from '@monorepo/shared/src/hooks/use-page';
import { MaybeWrapper } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { PageViewType } from '../../../types';
import BasePdfDocument from './BasePdfDocument';

const MaybePaper = MaybeWrapper(Paper);

const DoublePagePdf = ({ paperWrapper, leftPage, rightPage }) => {
  const [{ zoomed, noOfPages, currentPage }] = usePage();
  const classes = useStyles();

  const shouldRenderPage = (noOfPages: number, page): boolean => {
    const pageValid =
      page && !isNil(page.pageProps.pageNumber) && !isNaN(page.pageProps.pageNumber);

    if (noOfPages === PageViewType.OnePage) {
      return pageValid && currentPage % 2 === page.pageProps.pageNumber % 2;
    }

    return pageValid;
  };

  return (
    <MaybePaper
      shouldRender={paperWrapper}
      className={`${classes.paper} ${zoomed ? classes.zoomed : ''}`}
    >
      {shouldRenderPage(noOfPages, leftPage) && (
        <BasePdfDocument documentProps={leftPage.documentProps} pageProps={leftPage.pageProps} />
      )}
      {shouldRenderPage(noOfPages, rightPage) && (
        <BasePdfDocument documentProps={rightPage.documentProps} pageProps={rightPage.pageProps} />
      )}
    </MaybePaper>
  );
};

const useStyles = makeStyles(() => ({
  paper: {
    display: 'flex',
    height: '95%',
    alignSelf: 'flex-start',
    ['@media (max-height:800px)']: {
      height: '70vh',
    },
  },
  zoomed: {
    overflow: 'auto',
  },
}));

export default DoublePagePdf;
